export const addGoogleAnalytics = (dc) => {
  let asl = document.createElement('script')
  asl.async = true
  asl.src = 'https://www.googletagmanager.com/gtag/js?id=UA-119955855-1'
  dc.appendChild(asl)

  let asc = document.createElement('script')
  asc.text = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-119955855-1');`
  dc.appendChild(asc)

  // AdWords: 923131705
  let awl = document.createElement('script')
  awl.async = true
  awl.src = 'https://www.googletagmanager.com/gtag/js?id=AW-923131705'
  dc.appendChild(awl)

  let awc = document.createElement('script')
  awc.text = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-923131705');`
  dc.appendChild(awc)
}
export const addNaverLog = (dc) => {
  let nsl = document.createElement('script')
  nsl.src = '//wcs.naver.net/wcslog.js'
  dc.appendChild(nsl)

  let nsc = document.createElement('script')
  dc.appendChild(nsc)

  nsl.onload = () => {
    nsc.text = `if (!wcs_add) var wcs_add={};
      wcs_add["wa"] = "s_1998cc90062b";
      if (!_nasa) var _nasa={};
      wcs.inflow("wavve.com");
      wcs_do(_nasa);`
  }
}
export const addFaceBookLog = (dc) => {
  let fsc = document.createElement('script')
  fsc.text = `!function(f,b,e,v,n,t,s){
      if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '160912788027100');
      fbq('track', 'PageView');`
  dc.appendChild(fsc)

  let fnc = document.createElement('noscript')
  let img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = 'https://www.facebook.com/tr?id=160912788027100&ev=PageView&noscript=1'
  fnc.appendChild(img)
  dc.appendChild(fnc)

  let fpc = document.createElement('script')
  fpc.charset = 'UTF-8'
  fpc.src = '//t1.daumcdn.net/adfit/static/kp.js'
  dc.appendChild(fpc)

  let fpv = document.createElement('script')
  dc.appendChild(fpv)
  fpc.onload = () => {
    fpv.text = 'kakaoPixel(\'5419070585473843165\').pageView();'
  }
}

export const addCresendo = (dc) => {
  let ccs = document.createElement('script')
  ccs.type = 'text/javascript'
  ccs.src = '/static/js/cresendoScriptV60.js'
  dc.appendChild(ccs)
}

export const addAceCounter = () => {
  /* eslint-disable */
  var _AceTM = (function (_j, _s, _b, _o, _y) {
    var _uf = 'undefined', _pmt = '', _lt = location;
    var _ap = String(typeof(_y.appid) != _uf ? _y.appid() : (isNaN(window.name)) ? 0 : window.name);
    var _ai = (_ap.length != 6) ? (_j != 0 ? _j : 0) : _ap;
    if (typeof(_y.em) == _uf && _ai != 0) {
      var _sc = document.createElement('script');
      var _sm = document.getElementsByTagName('script')[0];
      var _cn = {
        tid: _ai + _s,
        hsn: _lt.hostname,
        hrf: (document.referrer.split('/')[2]),
        dvp: (typeof(window.orientation) != _uf ? (_ap != 0 ? 2 : 1) : 0),
        tgp: '',
        tn1: _y.uWorth,
        tn2: 0,
        tn3: 0,
        tw1: '',
        tw2: '',
        tw3: '',
        tw4: '',
        tw5: '',
        tw6: '',
        tw7: _y.pSearch
      };
      _cn.hrf = (_cn.hsn != _cn.hrf) ? _cn.hrf : 'in';
      for (var _aix in _y) {
        var _ns = (_y[_aix]) || {};
        if (typeof(_ns) != 'function') {
          _cn.tgp = String(_aix).length >= 3 ? _aix : '';
          _cn.tn2 = _ns.pPrice;
          _cn.tn3 = _ns.bTotalPrice;
          _cn.tw1 = _ns.bOrderNo;
          _cn.tw2 = _ns.pCode;
          _cn.tw3 = _ns.pName;
          _cn.tw4 = _ns.pImageURl;
          _cn.tw5 = _ns.pCategory;
          _cn.tw6 = _ns.pLink;
          break;
        }
      }
      _cn.rnd = (new Date().getTime());
      for (var _alx in _cn) {
        var _ct = String(_cn[_alx]).substring(0, 128);
        _pmt += (_alx + "=" + encodeURIComponent((_ct != _uf) ? _ct : '') + "&");
      }
      _y.acid = _ai;
      _y.atid = _cn.tid;
      _y.em = _cn.rnd;
      _sc.src = ((_lt.protocol.indexOf('http') == 0 ? _lt.protocol : 'http:') + '//' + _b + '/' + _o) + '?' + _pmt + 'py=0';
      _sm.parentNode.insertBefore(_sc, _sm);
      window._AceTM = _y;
    }

    return _y;
  })(118828, 'AX-40-A', 'atm.acecounter.com', 'ac.js', window._AceTM || {});
  _AceTM.crossDomain="pooq.co.kr";
}

export const setLibFile = (d, s, id, url) => {
  let js;
  let fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = url;
  fjs.parentNode.insertBefore(js, fjs);
}
